// extracted by mini-css-extract-plugin
export default {"logbutton":"homenavbar_logbutton__lc-dU","faqdiv":"homenavbar_faqdiv__in8Fy","modall":"homenavbar_modall__g-bL6"};